import { useEffect } from 'react';
import { TextRoot } from 'trellis-components/components/Text/primitives';
import Raven from 'raven-js';
import { warnedTypes } from './customComponentWarnedTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomComponentFallbackAlpha = ({
  text,
  warnNamespace,
  warnComponentType
}) => {
  useEffect(() => {
    if (warnNamespace && warnComponentType) {
      const key = `${warnNamespace}/${warnComponentType}`;
      if (!warnedTypes.has(key)) {
        warnedTypes.add(key);
        Raven.captureMessage(`[CustomComponent] unregistered: ${warnNamespace}/${warnComponentType}`, {
          level: 'warning',
          tags: {
            namespace: warnNamespace,
            customComponentType: warnComponentType
          }
        });
      }
    }
  }, [warnNamespace, warnComponentType]);
  return /*#__PURE__*/_jsx(TextRoot, {
    as: "span",
    children: text
  });
};
export default CustomComponentFallbackAlpha;